export const messages = {
  pl: {
    results: "Ilosć produktów: ",
    fold: "zwiń zakładki",
    reset: "usuń filtry",
    empty_products: "brak produktów o zadanych parametrach",
    max: "max",
    min: "min",
    invalid: "wszystkie",
    price: "Cena katalogowa netto",
    phone: "na telefon",
    news: "nowość",
    rises: "podwyżka",
    reduce: "obniżka",
    sale: "wyprzedaż",
    pionowo: "pionowo",
    poziomo: "poziomo",
    Podtrzymanie: "Podtrzymanie",
    Miejsce_na_akumulator: "Miejsce na akumulator",
    Montaz: "Montaż",
    Porty_PoE: "Porty PoE (RJ45)",
    Porty_UPLINK: "Porty UpLink (RJ45)",
    Gniazda_SFP_UPLINK: "Gniazda SFP (1Gb/s)",
    Rejestrator: "Rejestrator",
    Wymiary_miejsca_na_rejestrator: "Miejsce na rejestrator",
    Wyjscie_zasilania_na_rejestrator: "Zasilanie rejestratora",
    // Zasilanie: "Zasilanie switcha",
    Zasilanie: "Napięcie wejściowe",
    Typ_switcha: "Rodzaj",
    Podtrzymanie: "Podtrzymanie",
    Akumulator: "Akumulator",
    // Typ_Szafy: 'Szafy RACK 19"', // switche
    Typ_Szafy: 'Typ szafy',
    Wyjscie_zasilania: "Napięcie wyjściowe",
    Wymiary_montazowe: "Wymiary montażowe",
    Wymiary_szafy: "Wymiary",
    Zgodnosc_z_normami: "Zgodność z normami",
    Transformator: "Transformator",
    Centrale: "Centrale",
    Wymiary: "Wymiary",
    Zamykanie: "Zamykanie zgodne z RODO",
    Wykonanie: "Wykonanie",
    Plyta_montazowa: "Płyta montażowa",
    Grupa: "Przeznaczenie",
    Grupa_Obudow: "Przeznaczenie",
    Grupa_Akcesoriow_2: "Przeznaczenie",
    Grupa_Akcesoriow_1: "Rodzaj",
    Bezpiecznik: "Bezpiecznik",
    Grupa_Akcesoriow_RACK: "Akcesoria do szaf RACK",
    Orientacyjny_czas_podtrzymania: "Orientacyjny czas podtrzymania",
    accessDenied: "Odmowa dostępu, błędne dane",
    Stopien_szczelnosci: "Stopień szczelności",
    login_form: "Logowanie do cennika",
    logging: "zaloguj",
    close: "zamknij",
    clear: "usuń filtry",
    Centrale_moduly: "Centrale / moduły",
    Wejscia___wyjscia: "Wejscia / wyjscia",
    Wyjscia_techniczne_typu_OC: "Wyjscia techniczne typu OC",
    Wyjscia_techniczne_typu_przekaznikowego: "Wyjscia techniczne typu przekaznikowego",
    Wyjscia_techniczne_elektroniczne_z_izolacja: "Wyjścia techniczne elektroniczne z izolacją",
    Wejscia_techniczne_elektroniczne_z_izolacja: "Wejścia techniczne elektroniczne z izolacją",
    Napiecie_wejsciowe: "Napięcie wejściowe",
    napiecie: "napięcie",
    Zabezpieczenia: "Zabezpieczenia",
    Serie_przetwornic: "Serie przetwornic",
    security: "Security",
    group_do_zasilaczy: "Do zasilaczy",
    group_na_akumulatory: "Na akumulatory",
    din: "DIN",
    dso: "DSO i PPOŻ",
    na_rejestratory_cctv: "Na rejestratory CCTV",
    do_zasilaczy: "do zasilaczy",
    na_akumulatory: "na akumulatory",
    teletechniczne: "Teletechniczne",
    plastikowe: "Plastikowe",
    rack: "RACK",
    z_systemem_zasilania: "Z systemem zasilania",
    Sygnalizacja: "Sygnalizacja",
    Prad_ladowania_akumulatora: "Prąd ładowania akumulatora",
    Gwarancja: "Gwarancja",
    zasilanie_rejestratora: 'z zasilaniem buforowym rejestratora',
    godziny: 'godziny',
    security_do_central_alarmowych: 'security do central alarmowych',
    security_do_ekspanderow: 'security do ekspanderow',
    security_do_klawiatur: 'security do klawiatur',
    security_do_nadajnikow: 'security do nadajnikow',
    security_do_kontroli_dostepu: 'security do kontroli dostepu',
    z_szynami_din: 'z szynami din',
    na_szyne_din: 'na szyne din',
    do_dso_i_ppoz: 'do dso i ppoz',
    puszki_instalacyjne_przeciwpozarowe: 'puszki instalacyjne przeciwpozarowe',
    obudowy_na_rejestratory_poziome: 'obudowy na rejestratory poziome',
    obudowy_na_rejestratory_pionowe: 'obudowy na rejestratory pionowe',
    teletechniczne_mieszkaniowe: 'teletechniczne mieszkaniowe',
    teletechniczne_uniwersalne: 'teletechniczne uniwersalne',
    obudowy_zapasu_kabla: 'obudowy zapasu kabla',
    obudowy_plastikowe: 'obudowy plastikowe',
    obudowy_i_szuflady_rack_19: 'obudowy i szuflady rack19',
    obudowy_z_profilami_rack_19: 'obudowy z profilami rack19',
    obudowy_i_systemy_zasilania_do_switchy_poe: 'obudowy i systemy zasilania do switchy poe',
    uniwersalne: 'uniwersalne',
    porownaj: 'porównaj',
    porownywane_produkty: 'Porównywane produkty',
    opcje_zaawansowane: 'opcje zaawansowane',
    szukaj_parametru: 'szukaj parametru ...',
    pokaz_ukryj_filtry: 'Dodaj/Usuń filtrowany atrybut',
    btn_show_filtry: 'dodaj/usuń filtr',
    sortuj_po: 'Sortuj po:',
    symbol: 'kod',
    cena_asc: 'cena rosnąco',
    cena_dsc: 'cena malejąco',
    cena_netto_detal: 'cena netto detal',
    cena_netto_detal_wyprzedaz: "cena netto detal, <b style='color: #066edd;  font- weight: normal;'>nie podlega rabatowaniu</b>",
    rosnaco: 'rosnąco',
    malejaco: 'malejąco',
    waluta: 'PLN'
  },
  en: {
    results: "Number of products: ",
    fold: "fold",
    reset: "filtrs remove",
    empty_products: "no products with specified parameters",
    max: "max",
    min: "min",
    invalid: "all",
    phone: "phone/e-mail",
    price: "xxxCena katalogowa netto",
    news: "news",
    rises: "rises",
    reduce: "reduce",
    sale: "sale",
    pionowo: "vertical",
    poziomo: "horizontal",
    Podtrzymanie: "xxxPodtrzymanie",
    Miejsce_na_akumulator: "Batteries",
    Montaz: "Installation",
    Porty_PoE: "PoE ports",
    Porty_UPLINK: "UpLink ports (RJ45)",
    Gniazda_SFP_UPLINK: "SFP UPLINK sockets",
    Rejestrator: "Recorder",
    Wymiary_miejsca_na_rejestrator: "Recorder space",
    Wyjscie_zasilania_na_rejestrator: "Recorder power supply",
    // Zasilanie: "xxxZasilanie switcha",
    Zasilanie: "Input voltage",
    Typ_switcha: "Type",
    Podtrzymanie: "Battery backup",
    Akumulator: "Battery",
    // Typ_Szafy: 'Szafy RACK 19"', // switche
    Typ_Szafy: 'RACK 19” cabinet type',
    Wyjscie_zasilania: "Output voltage",
    Wymiary_montazowe: "Mounting dimensions",
    Wymiary_szafy: "Dimensions",
    Zgodnosc_z_normami: "Compliance with standards",
    Grupa: "Destinations",
    Transformator: "Transformers",
    Centrale: "Installation of control panels",
    Wymiary: "Dimensions",
    Zamykanie: "Closing",
    Wykonanie: "Material",
    Plyta_montazowa: "Mounting plate",
    Grupa_Obudow: "Destinations",
    Grupa_Akcesoriow_2: "Destinations",
    Grupa_Akcesoriow_1: "Type",
    Bezpiecznik: "Fuses",
    Grupa_Akcesoriow_RACK: "xxxAkcesoria do szaf RACK",
    Orientacyjny_czas_podtrzymania: "Approximate backup time ",
    accessDenied: "xxxOdmowa dostępu, błędne dane",
    Stopien_szczelnosci: "IP protection class",
    login_form: "Logging into price list",
    logging: "logged in",
    close: "close",
    clear: "remove a filter",
    Centrale_moduly: "Control panels / modules",
    Wejscia___wyjscia: "Inputs / outputs",
    Wyjscia_techniczne_typu_OC: "xxxWyjscia techniczne typu OC",
    Wyjscia_techniczne_typu_przekaznikowego: "xxxWyjscia techniczne typu przekaznikowego",
    Wyjscia_techniczne_elektroniczne_z_izolacja: "xxxWyjścia techniczne elektroniczne z izolacją",
    Wejscia_techniczne_elektroniczne_z_izolacja: "xxxWejścia techniczne elektroniczne z izolacją",
    Napiecie_wejsciowe: "Input voltage",
    napiecie: "supply voltage",
    Zabezpieczenia: "Protections",
    Serie_przetwornic: "Voltage converter modules series DCDC",
    dso: "VAS and fire protection box",
    na_rejestratory_cctv: "For CCTV recorders",
    group_do_zasilaczy: "For power supplies",
    group_na_akumulatory: "For batteries ",
    teletechniczne: "Universal - telecommunication",
    plastikowe: "Plastic",
    rack: "RACK",
    z_systemem_zasilania: "With power supply system",
    Sygnalizacja: "xxxSygnalizacja",
    Prad_ladowania_akumulatora: "Battery charging current",
    Gwarancja: "Warranty",
    zasilanie_rejestratora: 'with power supply for DVR',
    godziny: 'hours',
    security_do_central_alarmowych: 'for control panels',
    security_do_ekspanderow: 'for expanders',
    security_do_klawiatur: 'for keypads',
    security_do_nadajnikow: 'for transmitters',
    security_do_kontroli_dostepu: 'for Access Control Systems',
    z_szynami_din: 'with DIN rails',
    na_szyne_din: 'on DIN rails',
    do_dso_i_ppoz: 'for VAS',
    do_zasilaczy: "for power supplies",
    na_akumulatory: "for batteries ",
    puszki_instalacyjne_przeciwpozarowe: 'fire protection installation boxes',
    obudowy_na_rejestratory_poziome: 'horizontal',
    obudowy_na_rejestratory_pionowe: 'vertical',
    teletechniczne_mieszkaniowe: 'telecommunication',
    teletechniczne_uniwersalne: 'Universal - telecommunication',
    obudowy_zapasu_kabla: 'excess cable housing',
    obudowy_plastikowe: 'plastic enclosures',
    obudowy_i_szuflady_rack_19: 'enclosures and RACK drawers',
    obudowy_z_profilami_rack_19: 'enclosures with RACK19 profiles',
    obudowy_i_systemy_zasilania_do_switchy_poe: 'power supply systems for PoE switches',
    uniwersalne: 'universal',
    porownaj: 'compare',
    porownywane_produkty: 'Comparable products',
    opcje_zaawansowane: 'advanced options',
    szukaj_parametru: 'search for a parameter ...',
    pokaz_ukryj_filtry: 'Add/Remove filtered attribute',
    btn_show_filtry: 'add/remove filter',
    sortuj_po: 'Sort:',
    symbol: 'code',
    cena_asc: 'ascending prices',
    cena_dsc: 'descending prices',
    cena_netto_detal: 'Net Retail Price',
    cena_netto_detal_wyprzedaz: 'cena netto detal, <b>nie podlega rabatowaniu</b>',
    rosnaco: 'ascending',
    malejaco: 'descending',
    waluta: '$'
  },
};



// WEBPACK FOOTER //
// ./src/translations/messages.js